import { motion } from "framer-motion";

export default function Gallery({ items }) {
  if (!items?.length) return null;
  return (
    <section id="gallery" className="max-w-7xl mx-auto px-6 py-20 lg:py-28" data-testid="gallery-section">
      <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-[#FF5A1F]" data-testid="gallery-eyebrow">Our Work</p>
      <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="gallery-heading">
        Recent wholesale orders
      </h2>
      <p className="mt-4 max-w-2xl text-base md:text-lg text-slate-400 leading-relaxed">
        Real production runs for brands, clubs and businesses. Your order could be next.
      </p>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((g, i) => (
          <motion.figure key={g.id}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 3) * 0.08 }}
            className="group bg-[#161B22] border border-white/10 rounded-2xl overflow-hidden hover:border-[#FF5A1F]/40 transition-colors"
            data-testid={`gallery-item-${g.id}`}>
            <div className="h-64 overflow-hidden">
              <img src={g.image} alt={g.title} loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <figcaption className="p-5">
              <p className="font-heading font-bold" data-testid={`gallery-title-${g.id}`}>{g.title}</p>
              <p className="mt-1 text-sm text-slate-400">{g.caption}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
